import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';
import { createVendaProducaoAgricola, updateVendaProducaoAgricola } from '../service';
import { 
  attachFiles,
  deleteAttachFiles,
  attachFilesToContaReceber,
  deleteAttachFilesFromContaReceber,
} from '../service';
import {
  CREATE_VENDA_PRODUCAO_AGRICOLA,
  CREATE_VENDA_PRODUCAO_AGRICOLA_PENDING,
  CREATE_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
  CREATE_VENDA_PRODUCAO_AGRICOLA_FAILURE,
  CONFIG_SESSION,
} from '@handler';
import { storage } from '@commons/storage';
import {
  AlertSuccess,
  AlertError,
  AlertWarning,
} from '@components/common/AlertToast';
import { formatJsonRemoveEmptyOrNull } from '@components/common/format';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaCreateVendaProducaoAgricola(action) {
  yield put({ type: CREATE_VENDA_PRODUCAO_AGRICOLA_PENDING });

  var processar = true;
  if (processar) {
    try {
      if (!action.data.lancaProduto) {
        action.data.itens = [];
      }
      
      if (!action.data.vendaDup.geraDuplicata) {
        action.data.vendaDup.tipoDuplicata = null;
        action.data.vendaDup.contaGerencial = null;
        action.data.vendaDup.centroCusto = null;
        action.data.vendaDup.historico = '';
        action.data.vendaDup.tipoPagamento = null;
        action.data.vendaDup.contaCaixa = null;
        action.data.vendaDup.contaBanco = null;
        action.data.vendaDup.numeroParcelas = null;
        action.data.parcelas = [];
      } else if (action.data.vendaDup.geraDuplicata) {
        if (action.data.vendaDup.tipoDuplicata === 'A_VISTA') {
          action.data.vendaDup.numeroParcelas = null;
          action.data.parcelas = [];
          if (action.data.vendaDup.movimentaFinanceiro === false) {
            action.data.vendaDup.contaGerencial = null;
            action.data.vendaDup.centroCusto = null;
            action.data.vendaDup.historico = '';
            action.data.vendaDup.tipoPagamento = null;
            action.data.vendaDup.contaCaixa = null;
            action.data.vendaDup.contaBanco = null;
          }
        } else if (action.data.vendaDup.tipoDuplicata === 'PARCELADA' && action.data.vendaDup.movimentaFinanceiro === false) {
          for (var i = 0; i < action.data.parcelas.length; i++) {
            action.data.parcelas[i].contaGerencial = null;
            action.data.parcelas[i].centroCusto = null;
            action.data.parcelas[i].historico = '';
            action.data.parcelas[i].parcelaPaga = false;
            action.data.parcelas[i].tipoPagamento = null;
            action.data.parcelas[i].contaCaixa = null;
            action.data.parcelas[i].contaBanco = null;
          }
        }
      }

      if (action.data.talhao !== undefined && action.data.talhao != null){
        if (action.data.talhao.talhao !== undefined && action.data.talhao.talhao !== null) {
          action.data.talhao = action.data.talhao.talhao;
        }
      }

      // Coleta informações sobre anexos e duplicatas
      let anexosInfo = [];
      
      if (action.data.vendaDup && action.data.vendaDup.geraDuplicata && action.data.vendaDup.movimentaFinanceiro) {
        // Para duplicata à vista
        if (action.data.vendaDup.tipoDuplicata === 'A_VISTA') {
          const temArquivosUpload = action.data.vendaDup.filesToUploadList && 
                                   action.data.vendaDup.filesToUploadList.length > 0;
          const temArquivosDelete = action.data.vendaDup.filesToDeleteList && 
                                   action.data.vendaDup.filesToDeleteList.length > 0;
          
          if (temArquivosUpload || temArquivosDelete) {
            anexosInfo.push({
              tipo: 'A_VISTA',
              historico: action.data.vendaDup.historico || '',
              files: action.data.vendaDup.filesToUploadList || [],
              filesToDelete: action.data.vendaDup.filesToDeleteList || []
            });
          }
        } 
        // Para duplicatas parceladas
        else if (action.data.vendaDup.tipoDuplicata === 'PARCELADA' && action.data.parcelas && action.data.parcelas.length > 0) {
          for (let index = 0; index < action.data.parcelas.length; index++) {
            const parcela = action.data.parcelas[index];
            
            const parcelaHistorico = (parcela.historico || '') + ` - Parc. ${index + 1}/${action.data.parcelas.length}`;
            action.data.parcelas[index].historico = parcelaHistorico;
            
            // CORREÇÃO: Incluir parcelas que tenham arquivos para upload OU para deletar
            const temArquivosUpload = parcela.filesToUploadList && parcela.filesToUploadList.length > 0;
            const temArquivosDelete = parcela.filesToDeleteList && parcela.filesToDeleteList.length > 0;
            
            if (parcela.anexarDoc && (temArquivosUpload || temArquivosDelete)) {
              anexosInfo.push({
                tipo: 'PARCELADA',
                index: index,
                numeroParcelaTxt: `Parc. ${index + 1}/${action.data.parcelas.length}`,
                historico: parcelaHistorico,
                files: parcela.filesToUploadList || [], // Pode ser vazio se só tem arquivos para deletar
                filesToDelete: parcela.filesToDeleteList || []
              });
            }
          }
        }
      }

      // **CORREÇÃO: Criar uma cópia limpa dos dados sem os arquivos de anexo**
      const dadosParaEnvio = { ...action.data };
      
      // Remove arquivos da duplicata à vista
      if (dadosParaEnvio.vendaDup) {
        const { filesToUploadList, filesToDeleteList, anexarDoc, ...vendaDupLimpa } = dadosParaEnvio.vendaDup;
        dadosParaEnvio.vendaDup = vendaDupLimpa;
      }
      
      // Remove arquivos das parcelas
      if (dadosParaEnvio.parcelas && dadosParaEnvio.parcelas.length > 0) {
        dadosParaEnvio.parcelas = dadosParaEnvio.parcelas.map(parcela => {
          const { filesToUploadList, filesToDeleteList, anexarDoc, ...parcelaLimpa } = parcela;
          return parcelaLimpa;
        });
      }

      if (action.data.id === undefined || action.data.id === null) {
        const resp = yield call(createVendaProducaoAgricola, formatJsonRemoveEmptyOrNull({
          ...dadosParaEnvio, // Usando dados limpos sem arquivos
          propriedade: {
            id: JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id
          },
          safra: {
            id: JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva.id
          } 
        }));
        trackingEventCX('action', MODULE_ACTIONS_ENUM.VENDA_PROD_AGRICOLA_CRIAR);

      if (resp.status == 201) {
        // Anexar arquivos à nota principal
        if (action.filesToAttach && action.filesToAttach.length > 0) {
          yield call(attachFiles, resp.data.id, action.filesToAttach);
          trackingEventCX('action', MODULE_ACTIONS_ENUM.FILE_STORAGE);
        }
                
        // Processar anexos para duplicatas
        if (anexosInfo.length > 0 && resp.data.lancamentosContaReceber) {
          const lancamentos = resp.data.lancamentosContaReceber || [];
          
          // Para cada informação de anexo, encontrar o lancamento correspondente
          for (const anexo of anexosInfo) {
            let contaReceberId = null;
            
            // Tenta encontrar o lancamento correspondente com base no historico
            for (const lancamento of lancamentos) {
              if (anexo.tipo === 'A_VISTA') {
                // Para à vista, procuramos por um historico que corresponda exatamente
                if (lancamento.historico === anexo.historico) {
                  contaReceberId = lancamento.id; // Este é o ID retornado
                  break;
                }
              } else if (anexo.tipo === 'PARCELADA') {
                // Para parcelada, procuramos por um historico que contenha o texto da parcela
                if (lancamento.historico && lancamento.historico.includes(anexo.numeroParcelaTxt)) {
                  contaReceberId = lancamento.id; // Este é o ID retornado
                  break;
                }
              }
            }
                    
            // Se não encontramos pelo histórico e é uma duplicata À VISTA com apenas um lancamento
            if (!contaReceberId && anexo.tipo === 'A_VISTA' && lancamentos.length === 1) {
              contaReceberId = lancamentos[0].id; // Pega o único lançamento criado
            }
            
            // Se ainda não encontramos mas é uma duplicata PARCELADA e temos o mesmo número de lancamentos
            if (!contaReceberId && anexo.tipo === 'PARCELADA' && 
                action.data.parcelas && lancamentos.length === action.data.parcelas.length) {
              // Usa o índice da parcela para pegar o lancamento correspondente
              contaReceberId = lancamentos[anexo.index].id;
            }
            
            // Se encontramos um ID, anexa os arquivos usando o ID do conta a receber retornado
            if (contaReceberId) {
              if (anexo.files && anexo.files.length > 0) {
                // Agora anexa os arquivos ao conta a receber específico usando seu ID
                yield call(attachFilesToContaReceber, contaReceberId, anexo.files);
                trackingEventCX('action', MODULE_ACTIONS_ENUM.FILE_STORAGE);
              }
            }
          }
        }
      }
      } else {
        let lancamentosContaReceber = [];
        action.data.lancamentosContaReceber.forEach(element => {
          lancamentosContaReceber = [
            ...lancamentosContaReceber,
            {
              "forJson": "contareceber",
              "id": element.id,
              "valor": element.valor,
              "historico": element.historico,
              "propriedade": { "id": element.propriedade.id },
              "contaGerencial": {
                "id": element.contaGerencial.id,
                "tipoConta": "A"
              }
            }
          ]
        });
        
        const resp = yield call(updateVendaProducaoAgricola,
          {
            ...dadosParaEnvio, // Usando dados limpos sem arquivos
            lancamentosContaReceber: lancamentosContaReceber,
            id: action.data.id
          }
        );
        trackingEventCX('action', MODULE_ACTIONS_ENUM.VENDA_PROD_AGRICOLA_EDITAR);

        if (action.filesToAttach &&  action.filesToAttach.length > 0) {
          yield call(attachFiles, action.data.id, action.filesToAttach);
          trackingEventCX('action', MODULE_ACTIONS_ENUM.FILE_STORAGE);
        }
        if (action.filesIdToDelete &&  action.filesIdToDelete.length > 0) {
          yield call(deleteAttachFiles, action.data.id, action.filesIdToDelete);
        }

        // Processar anexos para duplicatas no caso de atualização
        if (resp && resp.lancamentosContaReceber && resp.lancamentosContaReceber.length > 0) {
          const lancamentos = resp.lancamentosContaReceber || [];
          
          // Para cada informação de anexo, encontrar o lancamento correspondente usando os NOVOS IDs
          for (const anexo of anexosInfo) {
            let contaReceberId = null;
            
            // Tenta encontrar o lancamento correspondente com base no historico
            for (const lancamento of lancamentos) {
              if (anexo.tipo === 'A_VISTA') {
                if (lancamento.historico === anexo.historico) {
                  contaReceberId = lancamento.id; // NOVO ID retornado pela API
                  break;
                }
              } else if (anexo.tipo === 'PARCELADA') {
                if (lancamento.historico && lancamento.historico.includes(anexo.numeroParcelaTxt)) {
                  contaReceberId = lancamento.id; // NOVO ID retornado pela API
                  break;
                }
              }
            }
            
            // Fallback: Se não encontramos pelo histórico, tentamos mapear por índice
            if (!contaReceberId && anexo.tipo === 'A_VISTA' && lancamentos.length === 1) {
              contaReceberId = lancamentos[0].id; // NOVO ID retornado pela API
            }
            
            if (!contaReceberId && anexo.tipo === 'PARCELADA' && 
                action.data.parcelas && lancamentos.length === action.data.parcelas.length) {
              contaReceberId = lancamentos[anexo.index].id; // NOVO ID retornado pela API
            }
            
            // Se encontramos um ID (NOVO da API), anexa/remove os arquivos
            if (contaReceberId) {
              if (anexo.files && anexo.files.length > 0) {
                yield call(attachFilesToContaReceber, contaReceberId, anexo.files);
                trackingEventCX('action', MODULE_ACTIONS_ENUM.FILE_STORAGE);
              }
              if (anexo.filesToDelete && anexo.filesToDelete.length > 0) {
                yield call(deleteAttachFilesFromContaReceber, contaReceberId, anexo.filesToDelete);
              }
            }
          }
        }
      }

      yield put({ type: CREATE_VENDA_PRODUCAO_AGRICOLA_SUCCESS, registro: action.data });

      history.push('/agricultura/producao/venda');
      AlertSuccess('Venda registrada com sucesso!');
    } catch (error) {
      yield put({ type: CREATE_VENDA_PRODUCAO_AGRICOLA_FAILURE, registro: action.data });

      // Verificar se é erro 422 com mensagem específica do backend
      const errorStatus = error?.response?.status || error?.status;
      const errorMessage = error?.response?.data?.text || error?.response?.data?.message || error?.data?.message;

      if (errorStatus === 422 && errorMessage) {
        // Mostrar mensagem específica do backend para erro 422
        AlertWarning(errorMessage);
      } else {
        // Mostrar mensagem padrão para outros erros
        AlertError('Falha ao salvar a venda! Tente novamente...');
      }
    }
  } else {
    yield put({ type: CREATE_VENDA_PRODUCAO_AGRICOLA_FAILURE, registro: action.data });
    AlertWarning('Venda não pode ser editada, pois já houve emissão de NFe');
  }
}

export default function* watchCreateVendaProducaoAgricola() {
  yield takeLatest(CREATE_VENDA_PRODUCAO_AGRICOLA, sagaCreateVendaProducaoAgricola);
}